import { render, staticRenderFns } from "./CreateInspector.vue?vue&type=template&id=47d2a847"
import script from "./CreateInspector.vue?vue&type=script&lang=js"
export * from "./CreateInspector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports